var _path, _ellipse, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPadiUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H36C39.3137 0 42 2.68629 42 6V36C42 39.3137 39.3137 42 36 42H6C2.68629 42 0 39.3137 0 36V6Z",
    fill: "#FF4C51",
    fillOpacity: 0.16
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.7501,
    cy: 15.5833,
    rx: 4.33333,
    ry: 4.33333,
    stroke: "#FF4C51",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 30.75V28.5833C11.25 26.1901 13.1901 24.25 15.5833 24.25H19.9167C22.3099 24.25 24.25 26.1901 24.25 28.5833V30.75",
    stroke: "#FF4C51",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 19.1666C24.919 19.1666 24.5833 19.5024 24.5833 19.9166C24.5833 20.3308 24.919 20.6666 25.3333 20.6666V19.1666ZM31.8333 20.6666C32.2475 20.6666 32.5833 20.3308 32.5833 19.9166C32.5833 19.5024 32.2475 19.1666 31.8333 19.1666V20.6666ZM29.3333 16.6666C29.3333 16.2524 28.9975 15.9166 28.5833 15.9166C28.169 15.9166 27.8333 16.2524 27.8333 16.6666H29.3333ZM27.8333 23.1666C27.8333 23.5808 28.169 23.9166 28.5833 23.9166C28.9975 23.9166 29.3333 23.5808 29.3333 23.1666H27.8333ZM25.3333 20.6666H31.8333V19.1666H25.3333V20.6666ZM27.8333 16.6666V23.1666H29.3333V16.6666H27.8333Z",
    fill: "#FF4C51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadiUser);
export default __webpack_public_path__ + "static/media/padi-user.bf2a0b86f896df4f11d45aedb3beac78.svg";
export { ForwardRef as ReactComponent };